module.exports = __webpack_public_path__ + "img/proficient_default.65f04433.png";